import React, { Component } from 'react';
import PropTypes from 'prop-types';
import shortid from 'shortid';
import { connect } from 'react-redux';
import { replace } from 'lodash';
import { withRouter, Switch, Route } from 'react-router-dom';
import FeedbackRequestAutomationIndexPage from './FeedbackRequestAutomationIndexPage';
import FeedbackRequestAutomationDetailPage from './FeedbackRequestAutomationDetailPage';
import Pusher from '../../../../components/pusher';

class FeedbackRequestAutomation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sessionId: shortid.generate(), // if user open another window, this suppose to be uniq
    };
    this.handleAutomationUpdate = this.handleAutomationUpdate.bind(this);
  }

  handleAutomationUpdate(evt) {
    if (evt.type !== 'automation') {
      return;
    }
    const { location: { pathname } } = this.props;
    const base = '/setup/feedback-requests/automations';
    const { id, sessionId, name, user } = evt;
    const isSessionMatch = sessionId === this.state.sessionId;

    // /setup/feedback-requests/automations
    // /setup/feedback-requests/automations/accounts/id
    // /setup/feedback-requests/automations/opportunities/id

    // extract the id from the pathname
   
    if (!isSessionMatch) {
      // different session (tab/window)

      let currentId = replace(pathname, `${base}/accounts/`, '');
      currentId = replace(currentId, `${base}/opportunities/`, '');
      const isRoot = pathname === base;
      const isDetail = currentId && currentId !== base;
      const isIdMatch = isDetail && currentId === id;
      if (isIdMatch) {
        // viewing detail, id match
        const el = (<div>Automation <strong>{name}</strong> has been updated by {user}! Please reload this page.</div>);
        this.context.addNotification(el, 
          { 
            type: 'warning', 
            autoClose: false,
            closeOnClick: false,
            onClose: () => {
              window.location.reload();
            },
          },
        );
      } else if (isRoot) {
        // is root
        const el = (<div>Automation <strong>{name}</strong> has been updated by {user}! This page will be reloaded.</div>);
        this.context.addNotification(el, 
          { 
            type: 'warning', 
            autoClose: 3 * 1000,
            closeOnClick: false,
            onClose: () => {
              window.location.reload();
            },
          },
        );
      }
      // otherwise: view detail of other automation, ignore
    }
  }

  render() {
    const { validCollectors, emergencySettings } = this.props;
    const { sessionId } = this.state;
    return (
      <div>
        <Switch>
          <Route
            exact
            path="/setup/feedback-requests/automations"
            render={(props) => {
              return (<FeedbackRequestAutomationIndexPage emergencySettings={emergencySettings} validCollectors={validCollectors} {...props} />);
            }}
          />
          <Route
            path="/setup/feedback-requests/automations/:type(opportunities|accounts)/:id"
            render={(props) => {
              return (<FeedbackRequestAutomationDetailPage emergencySettings={emergencySettings} validCollectors={validCollectors} {...props} sessionId={sessionId}  />);
            }}
          />
        </Switch>
        <Pusher event="automationUpdated" handler={this.handleAutomationUpdate} />
      </div>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps(/* state */) {
  return {
  };
}

FeedbackRequestAutomation.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  validCollectors: PropTypes.arrayOf(PropTypes.shape({})),
  emergencySettings: PropTypes.shape({
    disabled: PropTypes.bool,
  }),
};
FeedbackRequestAutomation.defaultProps = {
  validCollectors: [],
  emergencySettings: null,
};
FeedbackRequestAutomation.contextTypes = {
  addNotification: PropTypes.func.isRequired,
};


export default withRouter(connect(mapStateToProps)(FeedbackRequestAutomation));
